import { AuthenticationService } from "@cloudbreakus/authentication-service"
import { config } from "./configService"
import { logger } from "./logger"

export const authService = new AuthenticationService({
  config: config,
  logger: logger,
})
